// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-7ba5bd90]::-webkit-outer-spin-button,\ninput[data-v-7ba5bd90]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-7ba5bd90] {\n  -moz-appearance: textfield;\n}\n#app[data-v-7ba5bd90] {\n  position: relative;\n}\n.landing-page[data-v-7ba5bd90] {\n  background-color: #f2ede5;\n}", ""]);
// Exports
module.exports = exports;
